module.exports = __webpack_public_path__ + "assets/photos/memories/frame-6--7b4605dd9e6128a19a4be45c9c80d9f4.png";